import {Component, Input} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {layoutName} from './encoding-ladder.model';

/**
 * What is wrong with the audio rows as a set. These rules span rows (a duplicate pair, no required
 * layout), so no single table row owns them: the Audio card shows them, and so does the dialog that
 * is changing a row, where the cause is most likely to be made.
 */
@Component({
  selector: 'app-audio-errors',
  template: `
    @if (errors?.duplicatePair) {
      <p class="invalid-feedback d-block">
        Two rows deliver {{ errors.duplicatePair }} — that pairing is one rendition, so it would
        be encoded twice into the same file.
      </p>
    }
    @if (errors?.inconsistentLayout) {
      <p class="invalid-feedback d-block">
        The rows for {{ layoutName(errors.inconsistentLayout) }} disagree on bitrate, menu name
        or delivery — they are one layout in several codecs, so those have to match.
      </p>
    }
    @if (errors?.stereoOnlyCodec) {
      <p class="invalid-feedback d-block">
        {{ errors.stereoOnlyCodec }} carries its second channel parametrically and is only
        defined for stereo — set that row to 2 channels, or pick another codec.
      </p>
    }
    @if (errors?.noRequiredLayout) {
      <p class="invalid-feedback d-block">
        Mark one layout <b>Required</b>, or a source in a layout that is not listed ships with no audio
        the player is guaranteed to have.
      </p>
    }
    @if (errors?.duplicateRendition) {
      <p class="invalid-feedback d-block">
        Two renditions agree on codec, channels and bitrate ("{{ errors.duplicateRendition }}") —
        together those name the output file, so one would overwrite the other.
      </p>
    }
    @if (errors?.noRows) {
      <p class="invalid-feedback d-block">Add at least one rendition.</p>
    }
  `,
})
export class AudioErrorsComponent {
  @Input() errors: ValidationErrors | null = null;
  readonly layoutName = layoutName;
}
